import { FC, useState } from 'react';
import { translate } from '../../i18n';
import { amountInputStyles } from './styles';

export interface AmountInputProps {
  value?: number;
  onChange?: (value: number | undefined) => void;
  label?: string;
  testID?: string;
}

const parseAmount = (raw: string): number | undefined => {
  const normalized = raw.replace(/[^\d.]/g, '');
  if (normalized === '') return undefined;
  const parsed = Number(normalized);
  return Number.isNaN(parsed) ? undefined : parsed;
};

/**
 * AmountInput — Input de monto a abonar con una tarjeta (pago con 2 tarjetas)
 *
 * Sigue el mismo patrón que CVVInput:
 * ✅ Estilos centralizados en styles.ts
 * ✅ i18n para placeholder y aria-label
 * ✅ Cero Tailwind, cero hardcodes
 */
export const AmountInput: FC<AmountInputProps> = ({
  value,
  onChange,
  label,
  testID = 'amount-input',
}) => {
  const [rawValue, setRawValue] = useState(value !== undefined ? String(value) : '');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value;
    if (/^\d*\.?\d*$/.test(raw)) {
      setRawValue(raw);
      onChange?.(parseAmount(raw));
    }
  };

  return (
    <div style={amountInputStyles.container}>
      {label && (
        <label style={amountInputStyles.label} htmlFor={testID}>
          {label}
        </label>
      )}
      <input
        id={testID}
        type="text"
        inputMode="decimal"
        placeholder={translate('paymentsUI.amountInput.placeholder')}
        value={rawValue}
        onChange={handleChange}
        data-testid={testID}
        aria-label={translate('paymentsUI.amountInput.ariaLabel')}
        style={{ ...amountInputStyles.input }}
      />
    </div>
  );
};
